import {
  GET_PRODUCTIONS,
  GET_OPERATIONS,
  GET_OPERATION,
  SET_OPERATION_STATE,
  GET_STOP_REASONS,
  RETURN_TO_PRODUCTIONS,
  RETURN_TO_OPERATIONS,
  LOGOUT_USER
} from '../constants/ActionTypes'

const initialState = {
  productions: [],
  production: false,
  operations: [],
  operation: false,
  stopReasons: {
    break: [],
    failure: []
  }
}

export default function production(state = initialState, action) {
  switch (action.type) {
    case GET_PRODUCTIONS:
      return { ...state, productions: action.payload }
    case GET_OPERATIONS:
      return { ...state,
        production: action.payload.production,
        operations: action.payload.operations
      }
    case GET_OPERATION:
      return { ...state, operation: action.payload }
    case SET_OPERATION_STATE:
      return { ...state, operation: action.payload }
    case GET_STOP_REASONS:
      return { ...state,
        stopReasons: {
          ...state.stopReasons,
          [action.payload.event_type]: action.payload.reasons
        }
      }
    case RETURN_TO_OPERATIONS:
      return { ...state, operation: false }
    case RETURN_TO_PRODUCTIONS:
      return { ...state, operation: false, production: false, operations: [] }
    case LOGOUT_USER:
      return initialState
    default:
      return state
  }
}
